import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import Button from 'antd/lib/button';
import Modal from 'antd/lib/modal';
import Form from 'antd/lib/form';
import Input from 'antd/lib/input';
import Checkbox from 'antd/lib/checkbox';
import { Link } from 'react-router';
import rules from '../../common/rules/rules';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { cardPaymentActions, disableSavedCardRequest, fetchLoansActions, clearCardPaymentActions, selectPaymentUrl } from '../../features/loans/ducks';
import { selectIsInProgress } from '../../features/spinner/ducks';
import { apiCallIds } from '../../features/loans/api';
import { Spin } from 'antd';

const { Item } = Form;

const mapStateToProps = state => ({
  paymentUrl: selectPaymentUrl(state),
  isLoading: selectIsInProgress(state, apiCallIds.CARD_PAYMENT)
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      cardPayment: cardPaymentActions.request,
      fetchLoans: fetchLoansActions.request,
      disableSavedCard: disableSavedCardRequest,
      clearCardPayment: clearCardPaymentActions,

    },
    dispatch
  ),
});


@translate()
@Form.create()
@connect(mapStateToProps, mapDispatchToProps)
export default class CardPaymentModal extends Component {
  static propTypes = {

    loan: PropTypes.object,
    t: PropTypes.func.isRequired,
  };

  state = {
    payment: false,
    selectedCheckbox: null,
    step: 1,
    disableButtons: false
  }

  processedPaymentUrl = null
  submitLocked = false

  handleSubmit = e => {

	e.preventDefault()
    const { loan, actions, form, t } = this.props;
    form.validateFields((err, values) => {
		if (!err) {

      if(this.state.selectedCheckbox == null && this.state.step == 1) {
        this.setState({
          step: 2
        })
      }else{
        if(this.submitLocked) {
          return;
        }
        this.submitLocked = true;
        this.setState({
          disableButtons: true
        })
        if(this.state.payment === false){
          this.processedPaymentUrl = null;
          actions.clearCardPayment();
        }
        actions.cardPayment({ loanId: loan.id, data: values})
        if(this.state.payment === true){
        	window["openPopup"]()
        }
        else {
        	this.setState({
        		payment: true
        	})
        }
      }


		}
    });
  }

  componentDidUpdate(prevProps) {
    const { paymentUrl } = this.props;

    if (
      this.state.selectedCheckbox === 'type2' &&
      this.state.payment &&
      paymentUrl &&
      paymentUrl !== prevProps.paymentUrl &&
      paymentUrl !== this.processedPaymentUrl
    ) {
      this.processedPaymentUrl = paymentUrl;
      this.processSavedCardPayment(paymentUrl);
    }
  }

  processSavedCardPayment = async (paymentUrl) => {
    const { actions } = this.props;

    try {
      const res = await fetch(paymentUrl, { method: 'POST' });
      const response = await res.json();

      console.log(response);
      if(response.status === 'processing' || response.status === 'submitted') {
        return;
      }

      const resultCode = Number(response.ResultCode);
      if([0, 3, 4].includes(resultCode))
        window.location.href = '/admin/#/dashboard/loans?cardPayment=success';
      else
        window.location.href = '/admin/#/dashboard/loans?cardPayment=fail';
      actions.clearCardPayment();
      window.location.reload();
    }
    catch(error) {
      console.log(error);
      window.location.href = '/admin/#/dashboard/loans?cardPayment=fail';
      actions.clearCardPayment();
      window.location.reload();
    }
  }

  handleSaveAndSubmit = e => {
    this.setState({
      selectedCheckbox: 'type1'
    })
    this.props.form.setFieldsValue({
      'type1': true,
      'type2': false,
      'type3': false,
    });
    this.handleSubmit(e);
  }

  createIframe = (paymentUrl) => {
    if (paymentUrl == null){
      return null
    }
    if(this.state.selectedCheckbox === 'type2' && this.state.payment ){
      return null;
    }
	return {
		__html: `<iframe id="TrustPayFrame" allow="payment" src=${paymentUrl}
		style="position: fixed; inset: 0px; width: 100%; height: 100%; border: none; opacity: 1; transition: opacity 0.5s ease-in-out 0s; z-index: 99999;" >
		</iframe>`
	}
  }



  disableSavedCard = async () => {
    const { actions, loan } = this.props;
    const tt = await actions.disableSavedCard({loanId: loan.id});
    document.documentElement.scrollTop = 0;
    window.location.reload();
  }


  handleCheckboxChange = (event) => {
    const value = (event.target.id == this.state.selectedCheckbox) ? null : event.target.id;
    this.setState({
      selectedCheckbox: value,
    });
    this.props.form.setFieldsValue({
      'type1': false,
      'type2': false,
      'type3': false,
    });
    this.props.form.setFieldsValue({
      value: true,
    });
  };


  stepBack = e => {
    e.preventDefault()
    this.setState({
      step: 2
    })
  }


  moreInfo = e => {
    e.preventDefault()
    this.setState({
      step: 3
    })
  }


  resetSteps = e => {
    const { handleModalCancel } = this.props;
    e.preventDefault()
    this.processedPaymentUrl = null;
    this.submitLocked = false;
    this.setState({
      step: 1,
      payment: false,
      disableButtons: false
    })
    this.props.form.setFieldsValue({
      'type1': false,
      'type2': true,
      'type3': false,
    });
    handleModalCancel()
  }

  componentDidMount() {
    const { loan, form } = this.props;
    if(loan.savedCard)
      this.setState({
        selectedCheckbox: 'type2'
      })
    form.setFieldsValue({
      'type1': false,
      'type2': true,
      'type3': false,
    });
  }

  render() {
    const { handleModalCancel, isLoading, visible, maxPayment, currentDebt, paymentUrl ,loan, form,t } = this.props;
    const { getFieldDecorator } = form;
    return (
    <Spin spinning={isLoading}>
		<Modal
			visible={visible}
      width={this.state.step === 1 ? 580 : ( this.state.step === 2 ? 380 : 780)}
			title={this.state.step === 1 ? "Platba kartou" : ( this.state.step === 2 ? "Uloženie platobnej karty?" : "Bezpečnosť uložených údajov")}
			onCancel={this.resetSteps}
      footer={null}
			>
			{this.state.payment && (
				<div dangerouslySetInnerHTML={this.createIframe(paymentUrl)}>

				</div>
			)}
			<Form className={"carPaymentForm"}>
        <div className="step1" style={{ display: this.state.step === 1 ? 'block' : 'none' }}>
          <Item label={t('Zadajte sumu na zaplatenie')}>
          {getFieldDecorator('amount', { rules: [...rules.required, rules.currencyChecker, rules.lessThanValue(maxPayment)] , initialValue: currentDebt > 0 ? Number(currentDebt).toFixed(2) : Number(loan.installments[0].amount).toFixed(2)}, )(
            <Input size="default" />
          )}
          </Item>

          {loan.savedCard &&
            <div style={{ margin: '30px 0 15px 0', }}>
              {getFieldDecorator('type2', {initialValue: false,  })(<Checkbox checked={this.state.selectedCheckbox === 'type2'}  onChange={this.handleCheckboxChange} ><div style={{ width: '90%', display: 'inline-block', 'vertical-align': 'text-top' }}>{`Zrealizovať platbu uloženou kartou číslo ` + loan.savedCard.card + ` s dobou splatnosti ` + loan.savedCard.expiration + `` }<Link onClick={this.disableSavedCard}>  {`${t('(Zmazať kartu)')}`} </Link></div></Checkbox>)}

            </div>
          }


          <div style={{ margin: '15px 0 15px 0', display: 'none' }}>
            {getFieldDecorator('type1', {initialValue: false, })(<Checkbox checked={this.state.selectedCheckbox === 'type1'}  onChange={this.handleCheckboxChange}  ><div style={{ width: '90%', display: 'contents', 'vertical-align': 'text-top' }}>{`Uložiť kartu`}</div></Checkbox>)}
          </div>

          {!loan.automaticPayments &&
            <div style={{ margin: '15px 0 30px 0', }}>
              {getFieldDecorator('type3', {initialValue: false, style:{margin: 5+'px'} })(<Checkbox checked={this.state.selectedCheckbox === 'type3'}  onChange={this.handleCheckboxChange} ><div style={{ width: '90%', display: 'inline-block', 'vertical-align': 'text-top' }}>Nastaviť automatické splátky pôžičky - úhrada bude zrealizovaná automaticky z uloženej karty v deň splátky</div></Checkbox>)}
            </div>
          }
        </div>

        <div className="step2" style={{ display: this.state.step === 2 ? 'block' : 'none' }}>
          <p style={{padding: '20px 10px' }}>Uloženie údajov o platobnej karte zvýši pohodlie a zrýchli budúce úhrady.</p>
          <p style={{padding: '20px 10px' }}>Údaje sú u nás v bezpečí.<br/><Link onClick={this.moreInfo}>  {`${t('Viac informácií')}`} </Link></p>

          <p style={{padding: '30px 10px', 'border-top': '1px solid #e6e7e8', 'margin-top': '10px' }}>Ak chcete platiť pomocou Google/Apple Pay, zvoľte akciu "Preskočiť".</p>
        </div>

        <div className="step3" style={{ display: this.state.step === 3 ? 'block' : 'none' }}>
          <p style={{padding: '20px 10px' }}>Držiteľ karty jednorazovo zaregistruje svoju platobnú kartu jednoduchým a bezpečným spôsobom prostredníctvom platobnej služby TrustPay. Všetky citlivé kartové informácie sú počas prenosu zabezpečené a následne sú bezpečným spôsobom uchovávané v systéme platobnej služby. Maják.sk nemá prístup k citlivým údajom platobnej karty.</p>
          <p style={{padding: '20px 10px' }}>Pre registrovaného používateľa na stránke Maják.sk môže byť po vykonaní úspešnej transakcie karta registrovaná v systéme platobnej služby, pričom je súčasne generovaný tzv. alias / token karty. Ten si platobná služba so systémom Maják.sk vymení a obe strany si ho uchovajú. Všetky transakcie registrovanej karty sú iniciované prostredníctvom tokenu.</p>
        </div>

			</Form>

      <div className="flex-space-between modal-actions" style={{padding: '10px 16px 10px 10px', 'text-align': 'right', display: 'block' }}>
        <div className="step1" style={{ display: this.state.step === 1 ? 'block' : 'none' }}>
          <Button size='small' type='primary' onClick={this.handleSubmit} disabled={this.state.disableButtons}>
            Zaplatiť
          </Button>
        </div>
        <div className="step2"  style={{ display: this.state.step === 2 ? 'block' : 'none' }}>
          <Button size='small' type='' onClick={this.handleSubmit} style={{ 'margin-right': '10px' }} disabled={this.state.disableButtons}>
            Preskočiť
          </Button>
          <Button size='small' type='primary' onClick={this.handleSaveAndSubmit} disabled={this.state.disableButtons}>
            Uložiť kartu
          </Button>
        </div>
        <div className="step3"  style={{ display: this.state.step === 3 ? 'block' : 'none' }}>
          <Button size='small' type='primary' onClick={this.stepBack}>
            Rozumiem
          </Button>
        </div>
      </div>

		</Modal>
    </Spin>

    );
  }
}



// WEBPACK FOOTER //
// ./src/common/modals/CardPaymentModal.js